import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Course } from '../../models/application/course.interface';
import { CourseMethod } from '../../models/application/course-method.interface';

@Injectable({ providedIn: 'root' })
export class CourseService {
	private readonly relativeUrl = 'applications/';

	constructor(private readonly http: HttpClient) {}

	getCourseMethods(): Observable<Array<CourseMethod>> {
		return this.http.get<Array<CourseMethod>>(
			`${this.relativeUrl}courses/methods`
		);
	}

	addApplicationCourses(
		applicationId: number,
		courses: Array<Course>
	): Observable<Array<Course>> {
		return this.http.post<Array<Course>>(
			`${this.relativeUrl}${applicationId.toString()}/application-courses`,
			courses
		);
	}
}
